/**
 * 1) 만료된 인증 토큰 혹은 2) 잘못된 인증 토큰을 사용하는 경우 발생하는 에러
 */
export class GoogleOAuthUnauthorizedError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'GoogleOAuthUnauthorizedError';
  }
}
